<template>
    <div>
        <!--logo-->
        <img id="logo" :src="getLogo" alt="Logo" @click.prevent.stop="$router.push({name: 'home'})"/>
    </div>
</template>

<script>
export default {
    name: "Logo",
    data() {
        return {
            //
        }
    },
    computed: {
        getCompanyName: function() {
            return this.$store.getters.system_name === '' ? 'Webot' : this.$store.getters.system_name;
        },
        getLogo: function() {
            return this.$store.getters.system_logo === '' ? '//assets.office4u.xyz/common_asset/webot_logo.png' : this.$store.getters.system_logo;
        },
    }
}
</script>

<style scoped>
#logo {
    width: 170px;
    height: auto;
    padding-top: 50px;
    padding-bottom: 50px;
    cursor: pointer;
}

 @media only screen and (min-width : 992px) {
     #logo {
        width: 270px;
    }
 }

</style>
